import * as z from "zod";
import {
  wooCommerceCredentialsInputSchema,
  wooCommerceIntegrationSchema,
} from "./shared";

export const createWooCommerceIntegration = {
  name: "createWooCommerceIntegration" as const,
  input: wooCommerceCredentialsInputSchema.extend({
    ordersSyncIntervalSeconds: z.number().int().min(60).max(86_400).optional(),
  }),
  output: z.object({ integration: wooCommerceIntegrationSchema }),
};
